import { CartesDynamiques } from '@components/cartes-dynamiques/models';
import { kitchenLightMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const cartesDynamiquesMock: Block<CartesDynamiques> = {
  type: 'cartes-dynamiques',
  data: {
    title: {
      text: `Des cuisines sur mesures et [[accessibles]]`,
      as: 'span',
    },
    items: [kitchenLightMock, kitchenLightMock, kitchenLightMock, kitchenLightMock, kitchenLightMock],
    cta: {
      label: `Voir toutes nos cuisines`,
      url: '/mock-toutes-nos-cuisines',
    },
    gtmConfigCta: {
      event: 'click_cta_listing_cuisine_2',
      group: 'listing cuisine',
      description: 'cta bas de page hp',
      context: 'click second CTA homepage',
    },
  },
};
